module.exports = __webpack_public_path__ + "img/gift4.8c53e8f4.png";